import React, { useState, useEffect, useReducer } from 'react'
import * as yup from "yup"
import { Form, Formik } from 'formik';
import Modal from 'react-bootstrap/Modal';
import BlockSuccessMessage from '../../../../UI/errorMessages/BlockSuccessMessage';
import { formInitialState, formReducer } from '../../../../../reducers/formReducer';
import FormErrorMessage from '../../../../UI/errorMessages/FormErrorMessage';
import CMSFormTextArea from '../../../../UI/forms/CMSFormTextArea';
import { Button } from 'react-bootstrap';
import { ContainerLoading } from '../../../../UI/loading/ContainerLoading';
import axios from "../../../../../config/axios";
import { Store as toast } from 'react-notifications-component';
import { toastNotification } from '../../../../../config/toastNotification'
import CMSFormInput from '../../../../UI/forms/CMSFormInput';
import CMSFormSelect from '../../../../UI/forms/CMSFormSelect';


const ChangeStatusModal = ({ pollId, initialValue, show, setShow, loadItem }) => {
    const [formState, formDispatch] = useReducer(formReducer, formInitialState)

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onSubmit = async (data, resetForm) => {

        formDispatch({
            type: "FORM_SUBMISSION_REQUEST"
        });

        try {
            const res = await axios.post(`polls/change-status`, {
                id: pollId,
                status: data.status
            });
            formDispatch({
                type: "FORM_SUBMISSION_SUCCESS",
                payload: res.data
            });
            handleClose()
            toast.addNotification({
                ...toastNotification,
                title: "Success!",
                message: `Action performed successfully.`,
                type: "success",
            });
            resetForm();
            formDispatch({
                type: "FORM_INITIAL_STAGE"
            });
            loadItem()
        } catch (error) {
            formDispatch({
                type: "FORM_SUBMISSION_FAILED",
                payload: error
            });
            setTimeout(() => {
                formDispatch({
                    type: "FORM_INITIAL_STAGE"
                });
            }, 5000)
        }
    }

    return (
        <Formik
            initialValues={{
                id: pollId,
                status: initialValue,
            }}
            validationSchema={yup.object({
                status: yup.string().required(),
            })}
            enableReinitialize={true}
            validateOnChange={true}
            validateOnBlur={false}
            onSubmit={async (values, { resetForm }) => {
                onSubmit(values, resetForm)
            }}
        >
            {(form) => (

                <Modal show={show} onHide={handleClose}>
                    {(formState.isFormSubmitting) && <div class="overlay">
                        <i class="fas fa-2x fa-sync-alt text-white fa-spin"></i>
                    </div>}
                    <Form onSubmit={form.handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Change Poll Status</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {(formState.hasSubmissionError) &&
                                <FormErrorMessage error={formState.formSubmissionError} />
                            }
                            <CMSFormSelect
                                name="status"
                                label="Status"
                                required={true}
                                form={form}
                                options={[
                                    {
                                        label: "Disabled",
                                        value: "disabled"
                                    },
                                    {
                                        label: "Not Started",
                                        value: "notStarted"
                                    },
                                    {
                                        label: "Begun",
                                        value: "begun"
                                    },
                                    {
                                        label: "Finished",
                                        value: "finished"
                                    },
                                    {
                                        label: "Result Announce",
                                        value: "announced"
                                    },
                                    {
                                        label: "Archived",
                                        value: "archived"
                                    }
                                ]}
                            />
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                Close
                            </Button>
                            <Button variant="primary" type="submit">
                                Submit
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </Formik>
    )
}

export default ChangeStatusModal